import { streamChatMessages } from "../../actions/chats";

export const handleUnreadCountsFromBotMessage = (conversationId) => (dispatch, getState) => {
    const selectedConversationId = getState().chats?.selectedConversation?.conversationId;

    const callPaginatedQueueAPI = !selectedConversationId || selectedConversationId !== conversationId;

    if (callPaginatedQueueAPI) {
        dispatch(streamChatMessages(true));
    }
};